import '../assets/css/Notification.css'

const Notification = ({ showNotification, notificationMessage, setShowNotification }) => {
    return (
        <div className={`notification-container ${showNotification ? 'show' : 'hide'}`}>
            <div className="notification-content">
                <div className='notification-section'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path d="M10.4999 14.0026L12.8333 16.3359L18.0833 11.0859M8.55598 4.45775C9.49379 4.38291 10.3841 4.01414 11.1001 3.40393C12.7711 1.97994 15.2287 1.97994 16.8997 3.40393C17.6158 4.01414 18.506 4.38291 19.4439 4.45775C21.6323 4.63239 23.3701 6.37021 23.5448 8.55867C23.6196 9.49647 23.9884 10.3868 24.5986 11.1028C26.0226 12.7738 26.0226 15.2314 24.5986 16.9024C23.9884 17.6184 23.6196 18.5087 23.5448 19.4465C23.3701 21.635 21.6323 23.3728 19.4439 23.5475C18.506 23.6223 17.6158 23.9911 16.8997 24.6013C15.2287 26.0253 12.7711 26.0253 11.1001 24.6013C10.3841 23.9911 9.49379 23.6223 8.55598 23.5475C6.36752 23.3728 4.6297 21.635 4.45506 19.4465C4.38023 18.5087 4.01145 17.6184 3.40124 16.9024C1.97726 15.2314 1.97726 12.7738 3.40124 11.1028C4.01145 10.3868 4.38023 9.49647 4.45506 8.55867C4.6297 6.37021 6.36752 4.63239 8.55598 4.45775Z" stroke="#05171A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <p className="notification-text">
                        {notificationMessage}
                    </p>
                </div>
                <button className="notification-close" onClick={() => { setShowNotification(false) }}>
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 1L1 11M1 1L11 11" stroke="#05171A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
            </div>
        </div>
    )
}

export default Notification